import React from 'react';
import './index.scss';

interface CenteredWrapperProps {
  rounded?: boolean;
  bgColor?: string;
  children: React.ReactNode;
  outlined?: boolean;
  className?: string;
}

const CenteredWrapper = ({ children, rounded = true, bgColor = 'white', outlined = true, className = '' }: CenteredWrapperProps) => {
  return (
    <div className={`centered-wrapper ${className}`}>
      <div className={`centered-wrapper__content centered-wrapper__content--${rounded ? 'rounded' : ''} centered-wrapper__content--${outlined ? 'outlined' : ''}`} style={{ backgroundColor: bgColor }}>
        {children}
      </div>
    </div>
  );
};

export default CenteredWrapper;